var map = {
	"./damage-dent.png": "feed",
	"./damage-missing.png": "3c94",
	"./damage-other.png": "3b4d",
	"./damage-riven.png": "e9cd",
	"./damage-scratch.png": "37c8",
	"./damage-small.png": "e46c",
	"./damage-total.png": "68d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1227";